/**
 * One-way channel for asking the coding layout to open its Changes panel.
 *
 * The transcript draws the coding parts, so a "Changes" affordance belongs on
 * them — but the platform chat must not know that a diff column exists, and the
 * panel's open state is local to `CodeLayout`. Drilling a callback down through
 * Chat → Messages → Message → part would put a coding concern in four shared
 * components. An event keeps the dependency pointing one way: the part announces
 * intent, and the layout listens if it is mounted. Nothing breaks when it is not
 * — the same part rendered outside the coding surface simply does nothing.
 *
 * @module components/coding/open-diff-panel
 */

const OPEN_DIFF_EVENT = "taqat:code-open-diff";

/** Asks the coding layout to expand its Changes panel, if one is mounted. */
export function requestDiffPanel(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(OPEN_DIFF_EVENT));
}

/** Subscribes the layout to those requests. Returns an unsubscribe function. */
export function onDiffPanelRequested(handler: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  window.addEventListener(OPEN_DIFF_EVENT, handler);
  return () => window.removeEventListener(OPEN_DIFF_EVENT, handler);
}
